<template>
  <div v-if="object">
    <div class="row text-white" style="background: #8d8b77">
      <div class="col-md-10" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>{{item.object.name}}</b>
      </div>
      <div class="col-md-2" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-input label="Название"
                    v-model="object.name"
                    :placeholder="object.name">
        </base-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">
        <list-option :label="'Тип документа'" :object="object.document" :field="'pattern'"
                     :name="'name'" :objects="patterns" :value="'value'">
        </list-option>
      </div>
      <div class="col-md-3">
        <base-input label="Дата"
                    v-model="object.date"
                    :value="object.date"
                    :date="true"
        ></base-input>
      </div>
      <div class="col-md-3">
        <base-input label="Дата закрытия"
                    v-model="object.closeDate"
                    :value="object.closeDate"
                    :date="true"
        ></base-input>
      </div>
    </div>
  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false,
       patterns: []
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       this.inSave = true;
       try {
         let renewed = await this.$repo.save(this.object, this.type);
         if (renewed) {
           this.item.object = renewed;
           this.item.id = renewed.id;
           this.object = JSON.parse(JSON.stringify(renewed));
           this.inSave = false;
           this.toView();
         }
       } catch(error) {
         this.inSave = false;
       }
     },
     setGroup(value) {
       this.object.group = value;
     },
     setDC(value) {
       this.object.disabledCategory = value;
     },
     sleep(milliseconds) {
       const date = Date.now();
       let currentDate = null;
       do {
         currentDate = Date.now();
       } while (currentDate - date < milliseconds);
     }
   },
   async mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
     this.patterns = await this.$repo.getSelector('doc_pattern/list/CONTRACT');
     if (this.patterns) {
       this.patterns.forEach(pattern => pattern.name = pattern.value.name + ' (' + longAsStringDate(pattern.value.creationDate) + ')');
     } else {
       this.patterns = [];
     }
   }
 }
</script>
